// extracted by mini-css-extract-plugin
module.exports = {"dots":"src-components-common-dots-___dots__dots___3WP4t"};